import * as url from "../url.helper";

import { post } from "../api.helper";

export const callGetDealFinancier = data => post(url.GET_DEALFINACIER, data);

export const updateDealFinancierStatus = data => post(url.UPDATE_DEALFINACIER_STATUS, data);

export const callGetDealFinancierOperations = data => post(url.GET_DEALFINACIER_OPERATION, data);

export const callEditDealFinancierLead = data => post(url.UPDATE_DEALFINACIER_LEAD, data);

export const callEditDealFinancier = data => post(url.UPDATE_DEALFINACIER, data);

export const callAssignDealFinancier = data => post(url.Assign_DEAL_OTHERS, data);

export const callStatusCount = data => post(url.GET_DEAL_STATUS_COUNT, data);

export const callAssignToMeDealFinancier = data => post(url.Assign_DEAL_SELF, data);

export const callGetDealFinancierInfo = data => post(url.GET_DEAL_FIN_INFO, data);

export const callGetCIUser = data => post(url.GET_CI_USER, data);

export const callRMUsers = data => post(url.GET_RM, data);

export const callGetFinancier = data => post(url.FINANCIER_LIST, data);

export const callShowInterestFinancier = data => post(url.DEAL_SHOW_INTEREST, data);

export const callReferredFinancier = data => post(url.FINANCIER_REFERRED, data);

export const callAcceptedFinancier = data => post(url.FINANCIER_ACCEPTED, data);

export const callRejectedFinancier = data => post(url.FINANCIER_REJECTED, data);

export const callDeleteDeals=data=>post(url.DELETE_DEAL,data);

